export interface ThemeConfig {
  name: string;
  logos: {
    collapsed: string;
    notCollapsed: string;
  };
  browserTabFavicon: string;
  browserTabTitle: string;
  menuBackgroundColor: string;
  menuTextColor: string;
  menuHoverColor: string;
  menuSelectedBackgroundColor: string;
  menuSelectedTextColor: string;
  linkColor: string;
  submenuBackgroundColor: string;
  submenuTextColor: string;
  submenuHoverColor: string;
  submenuShadow: string;
}

export const defaultThemeTupi : ThemeConfig = {
  name: 'tupi',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
  menuSelectedBackgroundColor: '#f3f4f6',
  menuSelectedTextColor: '#5c00f0',
  linkColor: '#000000a6',
  submenuBackgroundColor: '#ffffff',
  submenuTextColor: '#000000a6',
  menuHoverColor: '#000000',
  submenuHoverColor: '#000000',
  submenuShadow: 'none',
  logos: {
    collapsed:
      'https://storage.googleapis.com/cpms-custom-themes-assets/tupi/logo_collapsed_1753135554.png',
    notCollapsed:
      'https://storage.googleapis.com/cpms-custom-themes-assets/tupi/logo_not_collapsed_1753135554.png',
  },
  browserTabFavicon: 'https://storage.googleapis.com/cpms-custom-themes-assets/tupi/browser_favicon_1753135554.png',
  browserTabTitle: 'Admin | Tupi',
}; 